var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChallenge(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 29.977,
    viewBox: "0 0 30 29.977",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1137",
    "data-name": "Groupe 1137",
    transform: "translate(-1427.5 -424)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_479",
    "data-name": "Groupe 479",
    transform: "translate(2886.066 -2233.967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1047",
    "data-name": "Trac\\xE9 1047",
    d: "M-1438.734,2681.113c-.256.227-.482.438-.721.637a.469.469,0,0,0-.168.535c.2.85.364,1.709.561,2.563a.381.381,0,0,1-.131.418c-.262.246-.48.645-.773.709s-.632-.232-.951-.373a9.03,9.03,0,0,0-12.491,6.711,9.027,9.027,0,0,0,7.614,10.5,9.041,9.041,0,0,0,10.162-7.422,8.9,8.9,0,0,0-.956-5.8c-.093-.174-.1-.287.062-.412a1.627,1.627,0,0,0,.319-.32.912.912,0,0,1,1.14-.348c.726.2,1.473.328,2.209.5a.4.4,0,0,0,.454-.139c.208-.246.435-.477.667-.73a13.95,13.95,0,0,1-4.008,16.684,14.014,14.014,0,0,1-18.713-1.027,14.048,14.048,0,0,1-1.156-18.539A14,14,0,0,1-1438.734,2681.113Z",
    transform: "translate(0.001 -19.98)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1048",
    "data-name": "Trac\\xE9 1048",
    d: "M-1371.841,2756.527c-.87.875-1.722,1.736-2.582,2.584a.433.433,0,0,1-.315.08,4.022,4.022,0,0,0-4.44,3.658,4.014,4.014,0,0,0,3.564,4.3,3.993,3.993,0,0,0,4.409-4.406.419.419,0,0,1,.061-.295c.857-.879,1.727-1.748,2.6-2.629a7.392,7.392,0,0,1-1.886,9.113,7.453,7.453,0,0,1-10.022-.467,7.467,7.467,0,0,1-.527-10A7.4,7.4,0,0,1-1371.841,2756.527Z",
    transform: "translate(-69.342 -89.279)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1049",
    "data-name": "Trac\\xE9 1049",
    d: "M-1322.181,2671.408a7.156,7.156,0,0,1,.873.211.332.332,0,0,0,.415-.1q2.873-2.877,5.749-5.752a.5.5,0,0,0,.114-.385c-.171-.877-.357-1.754-.557-2.625a.4.4,0,0,1,.113-.43c1.4-1.393,2.794-2.793,4.2-4.182a.556.556,0,0,1,.437-.172.6.6,0,0,1,.256.4q.344,1.5.65,3a.331.331,0,0,0,.309.3c.993.2,1.984.414,2.972.645.16.037.38.145.421.271s-.083.336-.2.451c-1.365,1.385-2.745,2.752-4.115,4.133a.481.481,0,0,1-.509.154c-.871-.2-1.747-.385-2.626-.559a.461.461,0,0,0-.357.1c-1.934,1.916-3.854,3.844-5.788,5.758-.164.16-.111.279-.057.451a2.339,2.339,0,0,1-.644,2.6,2.293,2.293,0,0,1-2.643.445,2.322,2.322,0,0,1-1.463-2.248A2.5,2.5,0,0,1-1322.181,2671.408Z",
    transform: "translate(-122.345 0.001)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChallenge);
export default __webpack_public_path__ + "static/media/challenge.8760ac22.svg";
export { ForwardRef as ReactComponent };